import { render, staticRenderFns } from "./OverlayLayout.vue?vue&type=template&id=20d57181&"
import script from "./OverlayLayout.vue?vue&type=script&lang=js&"
export * from "./OverlayLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports